<template>
  <div>
    <div class="title-header">
      <div class="title-header-font">{{ productDetailData.product_name }}</div>
    </div>
    <!--面包屑-->
    <CurrentLocal :titles="titles"></CurrentLocal>
    <!--主要内容-->
    <div style="width: 1200px; margin: 0 auto;">
      <!--走马灯和简介-->
      <div style="margin-bottom: 30px">
        <el-carousel :interval="5000" height="400px" style="width: 600px; float: left">
          <el-carousel-item v-for="(item, i) in productDetailData.image_paths" :key="i">
            <img :src="item" alt="" style="width: inherit; height: inherit; object-fit: contain;">
          </el-carousel-item>
        </el-carousel>
        <h2 style="padding: 12px;text-indent:1em">{{ productDetailData.product_name }}</h2>
        <div v-html="productDetailData.product_desc"
             style="font-size: 18px; font-weight: 500;letter-spacing: .06em;color: #71777c"></div>
      </div>
      <!--tab页-->
      <div style="clear: both; width: 100%; height: 1px"></div>
      <el-tabs value="1" type="border-card" class="product-tab">
        <el-tab-pane label="产品介绍" name="1">
          <span v-html="productDetailData.product_intro"
                style="font-size: 18px; font-weight: 500;letter-spacing: .06em;color: #71777c"></span>
        </el-tab-pane>
        <el-tab-pane label="产品参数" name="2">
          <span class="product-params" v-html="productDetailData.product_params"></span>
        </el-tab-pane>
        <el-tab-pane label="文件下载" name="3">
          <ProductDownload v-for="(item, i) in productDetailData.download" :key="i" :downloadItem="item"></ProductDownload>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import CurrentLocal from '@/components/CurrentLocal/CurrentLocal'
import ProductDownload from '@/views/product/ProductDownload'
import { productDetail } from '@/api/product'

export default {
  name: 'ProductDetail',
  components: { CurrentLocal, ProductDownload },
  data () {
    return {
      titles: [{ path: '/', name: '首页' },
        { path: '/product', name: '产品设备' },
        { path: '/product/' + this.$route.params.id, name: '' }],
      productDetailData: {}
    }
  },
  created () {
    this.getProductDetail()
  },
  methods: {
    getProductDetail () {
      productDetail(this.$route.params.id).then((res) => {
        if (res.body !== null) {
          this.productDetailData = res.body
          this.titles[2].name = this.productDetailData.product_name
        }
      })
    }
  }
}
</script>

<style>
  .el-carousel__item {
    background-color: #fafafa;
  }
  .product-tab {
    margin: 20px 0;
  }
  .product-tab .el-tabs__item {
    font-size: 20px;
    height: 60px;
    line-height: 60px;
    padding: 0 30px;
  }

  /*表格*/
  .product-params table {
    width: 75%;
    margin: 0 auto;
    font-size: 18px;
    color: #71777c;
    display: table;
    -webkit-border-horizontal-spacing: 0;
    -webkit-border-vertical-spacing: 0;
    border-top-width: 0;
    border-right-width: 0;
    border-bottom-width: 0;
    border-left-width: 0;
    table-layout: auto;
    border-collapse: separate;
  }
  .product-params table tr {
    display: table-row;
    vertical-align: inherit;
    border-color: inherit;
    transition: background-color .25s ease;
    border-bottom: 1px solid #ebeef5;
  }
  .product-params table tr:nth-child(2n) {
    background-color: #ffffff;
  }
  .product-params table tr:nth-child(2n+1) {
    background-color: #eff8ff;
  }
  .product-params table tr:hover {
    background-color: #ebeef5;
  }
  .product-params table td {
    border-bottom: 1px solid #ebeef5;
    padding: 16px 0;
    min-width: 0;
    box-sizing: border-box;
    text-overflow: ellipsis;
    vertical-align: middle;
    position: relative;
    text-align: left;
    display: table-cell;
    overflow: hidden;
    white-space: normal;
    word-break: break-all;
    line-height: 23px;
  }
</style>
